import * as Yup from 'yup';
import messages from './messages';

export const SignInSchema = Yup.object().shape({
  email: Yup.string()
    .email(messages.emailInvalid.id)
    .required(messages.emailRequired.id),
  password: Yup.string().required(messages.passwordRequired.id),
});
